module.exports = __webpack_public_path__ + "img/account_icon01.60f2ed3.webp";